// import * as actions from "./../actions/ui";
import { connect } from "react-redux";
// import { Dispatch } from "redux";
import DrillableFilterLink from "./../components/DrillableFilterLink";
import { StoreState } from "../types";

export function mapStateToProps({ query }: StoreState.All, ownProps: any) {
  return {
    currentFilterSelection: query.filters[ownProps.filterName],
    selectedReport: query.filters.selectedReport,
  };
}

// export function mapDispatchToProps(
//   dispatch: Dispatch<actions.FilterDrilldown>,
//   ownProps: any
// ) {
//   return {
//     onClick: () =>
//       dispatch(actions.filterDrilldown(ownProps.filterPanelDetailSectionName))
//   };
// }

export default connect(
  mapStateToProps,
  // mapDispatchToProps
)(DrillableFilterLink);
